import React, { useEffect, useState } from "react"
import { Grid, Typography } from "@mui/material"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import SelectMenuItems from "pages/private/learning_development/WeeklyChallenge/EditWeeklyChallenge/SelectMenuItems"
import AddMenuItems from "pages/private/marketing/menu/AddMenuItems"
import { useDispatch, useSelector } from "react-redux"
import {
  addItemsToSectionAction,
  getDynamicMenuFieldsAction,
  updatePreshiftAction,
  getVipCategoriesAction
} from "redux/superAdmin/actions/user"
import { marketingActions } from "redux/marketing/slice/user"
import CommonModal from "components/CommonModal"
import AppSelect from "components/StyledComponents/AppSelect"
import AppButton from "components/StyledComponents/AppButton"

const AddItemModal = ({
  open,
  onClose,
  sectionId,
  fieldId,
  preshiftId,
  onSaveDraft,
  sectionKey
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { menuSubCategory } = useSelector((state) => state.marketing?.menu || {})
  const { menuImageList, vipCategories } = useSelector((store) => store.superAdmin)
  const [selectedCategoryId, setSelectedCategoryId] = useState("")
  const [step, setStep] = useState("category")

  useEffect(() => {
    if (open) {
      setStep("category")
      setSelectedCategoryId("")
      if (sectionKey === "VIP_GUESTS") {
        dispatch(getVipCategoriesAction())
      }
    }
  }, [open, sectionKey])

  const categoryOptions = vipCategories || []

  const handleProceedToItems = () => {
    const selected = vipCategories.find((c) => c.value === selectedCategoryId)
    dispatch(
      marketingActions.setMenuLink({
        item: "vip",
        category: selected?.label || "",
        list: "detailed view"
      })
    )
    dispatch(getDynamicMenuFieldsAction({ category: "Vip" }))
    setStep("items")
  }

  const handleMenuSelect = (selectedItems) => {
    const items = Array.isArray(selectedItems) ? selectedItems : [selectedItems]
    const itemIds = items.map((item) => item.id)

    const triggerAddItems = () => {
      dispatch(
        addItemsToSectionAction({
          preshift_id: preshiftId,
          section_id: sectionId,
          payload: { item_ids: itemIds, field: fieldId },
          callback: () => onClose()
        })
      )
    }

    if (onSaveDraft) {
      onSaveDraft(triggerAddItems)
    } else {
      triggerAddItems()
    }
  }

  const handleGoToMenu = () => {
    dispatch(
      updatePreshiftAction({
        id: preshiftId,
        payload: { status: "DRAFT" },
        callback: () => {
          onClose()
          const linkItem = {
            item: menuImageList[0]?.name?.toLowerCase() || "",
            category: menuSubCategory[0]?.name || "",
            list: "Summary View"
          }
          dispatch(marketingActions.setMenuLink(linkItem))
          dispatch(getDynamicMenuFieldsAction({ category: menuImageList[0]?.name }))
          history.push("/marketing/dashboard/explore-menu")
        }
      })
    )
  }

  if (!open) return null

  if (sectionKey === "VIP_GUESTS" && step === "items") {
    return <AddMenuItems open={true} onClose={onClose} categoryId={selectedCategoryId} />
  }

  if (sectionKey === "VIP_GUESTS" && step === "category") {
    return (
      <CommonModal open={open} onClose={onClose} maxWidth="sm" hideAction={true}>
        <Typography variant="h2" className="mb-4 text-center" color="white">
          Select VIP Category
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AppSelect
              label="Select Category"
              menuItems={categoryOptions}
              value={selectedCategoryId}
              onChange={(e) => setSelectedCategoryId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} className="d-flex justify-content-center gap-3 mt-2">
            <AppButton onClick={onClose} variant="outlined" sx={{ height: 48, width: 150 }}>
              Cancel
            </AppButton>
            <AppButton
              onClick={handleProceedToItems}
              disabled={!selectedCategoryId}
              sx={{ height: 48, width: 150 }}>
              Next
            </AppButton>
          </Grid>
        </Grid>
      </CommonModal>
    )
  }

  return (
    <SelectMenuItems
      onClose={onClose}
      onSelect={handleMenuSelect}
      onGoToMenu={handleGoToMenu}
      module="PRESHIFT"
      isGenerateQuestion={false}
    />
  )
}

export default AddItemModal
